import React, { useState } from 'react';
import { Grid, Typography, Link, IconButton, Box, Container, Divider } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import './Footer.css';

const navData = [
  { name: "Our Story", id: "ourStory", link: "/our-story" },
  {
    name: "Capabilities",
    id: "capabilities",
    subMenu: true,
    subMenuItems: [
      { name: "Software Development", id: "softwareDevelopment", link: "/software-development" },
      { name: "Cloud Services", id: "cloudServices", link: "/cloud-services" },
      { name: "Product Engineering", id: "productEngineering", link: "/product-engineering" },
      // { name: "Video Engineering", id: "VideoEngineering", link: "/video-engineering" },
      { name: "SRE", id: "SRE", link: "/sre" },
    ]
  },
  {
    name: "Industries",
    id: "industries",
    subMenu: true,
    subMenuItems: [
      { name: "Banking & Finance Services", id: "banking", link: "/banking" },
      { name: "Capital Markets", id: "capitalMarkets", link: "/capital-Markets" },
      { name: "Communications, Media, and Information Services", id: "communications", link: "/communications" },
      { name: "Energy, Resources, and Utilities", id: "/energy", link: "/energy" },
      { name: "Healthcare", id: "Healthcare", link: "/healthcare" },
      { name: "Retail", id: "Retail", link: "/retail" },
      { name: "Travel and Logistics", id: "Travel", link: "/travel-logistics" },
      { name: "Automative & Aerospace and Defense", id: "Defense", link: "/defense" }
    ]
  },
  { name: "JAASC", id: "jassacLife", link: "/jassacLife" },
  { name: "Careers", id: "careers", link: "/careers" },
  // {
  //   name: "Insights",
  //   id: "Insights",
  //   subMenu: true,
  //   subMenuItems: [
  //     { name: "Customer Stories", id: "customerStories", link: "/customerStories" },
  //     { name: "Perspectives", id: "perspectives", link: "/perspectives" }
  //   ]
  // },
];


const Footer = () => {
  const setVisitedPage = (page) =>{
    localStorage.setItem("currentPage", page);
  }
  return (
    <Box sx={{ backgroundColor: "#1e2222", padding: "2rem 0", fontFamily: "'Barlow',Helvetica,Arial,Lucida,sans-serif" }}>
      <Container maxWidth="lg" sx={{width:'60%'}}>
        <Grid container spacing={6} justifyContent="space-between">
          {/* Section 1 */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" className="footerHeading">
               JAASC
            </Typography>
            {navData.map((item) => {
              if (!item.subMenu) {
                return (
                  <Link 
                    className="subMenuLinks" 
                    href={item.link} 
                    underline="none" 
                    color="textSecondary" 
                    display="block"
                    onClick={()=> setVisitedPage(item.id)}
                  >
                    {item.name}
                  </Link>
                )
              }
              return null;
            })}
          </Grid>

          {/* Section 2 */}
          <Grid item xs={12} sm={4} md={3}>
            <Typography variant="subtitle1" className="footerHeading">
              Industries
            </Typography>
            {navData[2].subMenuItems.map((item) => (
              <Link 
                className="subMenuLinks" 
                href={item.link} 
                underline="none" 
                color="textSecondary" 
                display="block"
                onClick={()=> setVisitedPage(item.id)}
              >
                {item.name}
              </Link>
            ))}
          </Grid>

          {/* Section 3 */}
          <Grid item xs={12} sm={4} md={3}>
            <Typography variant="subtitle1" className="footerHeading">
              Our Capabilities
            </Typography>
            {navData[1].subMenuItems.map((item) => (
              <Link 
                className="subMenuLinks" 
                href={item.link} 
                underline="none" 
                color="textSecondary" 
                display="block"
                onClick={()=> setVisitedPage(item.id)}
              >
                {item.name}
              </Link>
            ))}
          </Grid>

          {/* Section 4 */}
          {/* <Grid item xs={12} sm={4} md={3}>
            <Typography variant="subtitle1" className="footerHeading">
              Customer Stories
            </Typography>
            {navData[5].subMenuItems.map((item) => (
              <Link 
                className="subMenuLinks" 
                href={item.link} 
                underline="none" 
                color="textSecondary" 
                display="block"
                onClick={()=> setVisitedPage(item.id)}
              >
                {item.name}
              </Link>
            ))}
          </Grid> */}
        </Grid>

        <Divider sx={{ marginY: 4, borderColor: '#dfdee3 !important' }} />

        {/* Logo and Social Links */}
        <Grid container spacing={2} justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h6" sx={{color: '#fff'}}>
               <img src="images/logo.png" alt="logo" loading="lazy" id="logo" />
            </Typography>
          </Grid>
          <Grid item>
            <div className="social-icons">
              <IconButton
                href="#"
                target="_blank"
                className="social-icon"
                sx={{ color: '#fff', '&:hover': { color: '#3b5998' } }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href="#"
                target="_blank"
                className="social-icon"
                sx={{ color: '#fff', '&:hover': { color: '#FF0000' } }}
              >
                <YouTubeIcon />
              </IconButton>
              <IconButton
                href="#"
                target="_blank"
                className="social-icon"
                sx={{ color: '#fff', '&:hover': { color: '#1DA1F2' } }}
              >
                <TwitterIcon />
              </IconButton>
              <IconButton
                href="#"
                target="_blank"
                className="social-icon"
                sx={{ color: '#fff', '&:hover': { color: '#E4405F' } }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                href="#"
                target="_blank"
                className="social-icon"
                sx={{ color: '#fff', '&:hover': { color: '#0077b5' } }}
              >
                <LinkedInIcon />
              </IconButton>
            </div>
          </Grid>
        </Grid>

      </Container>
        {/* Footer Bottom */}
        <Divider sx={{ marginY: 4 , border: '1px solid #494c4d !important'}} />
        <Grid container justifyContent="space-between" alignItems="center" sx={{color: '#fff', width:"76%", margin:"0px auto"}}>
          <Grid item>
            <Typography variant="caption" color="textSecondary" sx={{color: '#fff'}}>
              © Copyright 2025 JAASC. All Rights Reserved
            </Typography>
          </Grid>
          <Grid item>
            <Link href="/terms-of-use" underline="none" color="textSecondary" sx={{color: '#fff'}}>
              Terms of Use
            </Link>
            <span> | </span>
            <Link href="/privacy-policy" underline="none" color="textSecondary" sx={{color: '#fff'}}>
              Privacy Policy
            </Link>
          </Grid>
        </Grid>
    </Box>
  )
};

export default Footer;